var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { EpicIntegration } from "healthex-common/document.retrieval.dtos";
import { computed, observable, reaction } from "mobx";
import { NamedRoutes } from "./NamedRoutes";
export var FacilitatedFHIRAuthState;
(function (FacilitatedFHIRAuthState) {
    FacilitatedFHIRAuthState["INACTIVE"] = "INACTIVE";
    FacilitatedFHIRAuthState["IN_PROGRESS"] = "IN_PROGRESS";
    FacilitatedFHIRAuthState["SUCCESS"] = "SUCCESS";
    FacilitatedFHIRAuthState["ERROR"] = "ERROR";
})(FacilitatedFHIRAuthState || (FacilitatedFHIRAuthState = {}));
export var FacilitatedFHIRAuthErrorReason;
(function (FacilitatedFHIRAuthErrorReason) {
    FacilitatedFHIRAuthErrorReason["AUTH_WINDOW_CLOSED"] = "AUTH_WINDOW_CLOSED";
    FacilitatedFHIRAuthErrorReason["AUTH_FAILED"] = "AUTH_FAILED";
    FacilitatedFHIRAuthErrorReason["WRONG_STATE"] = "WRONG_STATE";
    FacilitatedFHIRAuthErrorReason["NO_AUTH_DATA"] = "NO_AUTH_DATA";
})(FacilitatedFHIRAuthErrorReason || (FacilitatedFHIRAuthErrorReason = {}));
export class FacilitatedFHIRAuthManager {
    constructor(persistence, routingUIManager) {
        this.persistence = persistence;
        this.routingUIManager = routingUIManager;
        this.state = { state: FacilitatedFHIRAuthState.INACTIVE };
        reaction(() => this.routingUIManager.currentRoute, (currentRoute) => {
            if ((currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.routeName) === NamedRoutes.FACILITATED_FHIR_CALLBACK.routeName ||
                (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.routeName) === NamedRoutes.FACILITATED_FHIR_OPEN_EPIC_CALLBACK.routeName) {
                void this.processFacilitatedFHIRAuthCallback();
            }
            else if (currentRoute !== null) {
                this.resetAuthStateIfNeeded();
            }
        }, { fireImmediately: true, name: "FacilitatedFHIRAuthManager_currentRoute" });
        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                this.resetAuthStateIfNeeded();
            }
        });
    }
    get hasCompletedAuth() {
        return this.state.state === FacilitatedFHIRAuthState.SUCCESS || this.state.state === FacilitatedFHIRAuthState.ERROR;
    }
    redirectToFacilitatedFHIRLoginPage(key, url, state, callbackHash, fhirEndpoint) {
        this.state = { state: FacilitatedFHIRAuthState.IN_PROGRESS, key, fhirEndpoint };
        this.setFacilitatedFHIRAuthData({
            key,
            state,
            callbackHash,
            fhirEndpoint,
        });
        window.location.href = url;
    }
    async processFacilitatedFHIRAuthCallback() {
        const data = new URLSearchParams(window.location.search);
        const code = data.get("code");
        const state = data.get("state");
        const error = data.get("error");
        const authData = this.getFacilitatedFHIRAuthData();
        if (!authData) {
            this.onError(FacilitatedFHIRAuthErrorReason.NO_AUTH_DATA);
            return;
        }
        if (error) {
            this.onError(FacilitatedFHIRAuthErrorReason.AUTH_FAILED, authData === null || authData === void 0 ? void 0 : authData.key, authData === null || authData === void 0 ? void 0 : authData.fhirEndpoint);
        }
        else if (code) {
            if (authData.state !== state) {
                this.onError(FacilitatedFHIRAuthErrorReason.WRONG_STATE, authData === null || authData === void 0 ? void 0 : authData.key, authData === null || authData === void 0 ? void 0 : authData.fhirEndpoint);
                return;
            }
            this.onSuccess(authData.key, code, authData === null || authData === void 0 ? void 0 : authData.fhirEndpoint);
        }
        else {
            this.onError(FacilitatedFHIRAuthErrorReason.AUTH_FAILED, authData === null || authData === void 0 ? void 0 : authData.key, authData === null || authData === void 0 ? void 0 : authData.fhirEndpoint);
        }
        window.history.replaceState(null, "", window.location.href.replace(window.location.search, ""));
    }
    getRedirectUri(integration) {
        let origin = window.location.origin;
        if (integration === EpicIntegration.EPIC_NEXUS) {
            if (origin.includes("app.demo.healthex.dev"))
                origin = "https://app.healthex.dev";
        }
        const hashPath = integration === EpicIntegration.OPEN_EPIC ? "open-epic/redirect" : "epic-nexus/redirect";
        return `${origin}/#/${hashPath}`;
    }
    resetAuth() {
        this.state = { state: FacilitatedFHIRAuthState.INACTIVE };
    }
    handleAuthError(error, key) {
        this.onError(error, key);
    }
    onError(error, key, fhirEndpoint) {
        this.state = { state: FacilitatedFHIRAuthState.ERROR, key: key !== null && key !== void 0 ? key : "", error, fhirEndpoint };
    }
    onSuccess(key, code, fhirEndpoint) {
        this.state = { state: FacilitatedFHIRAuthState.SUCCESS, key, code, fhirEndpoint };
    }
    getFacilitatedFHIRAuthData() {
        return this.persistence.getFacilitatedFHIRAuthData();
    }
    setFacilitatedFHIRAuthData(authData) {
        this.persistence.setFacilitatedFHIRAuthData(authData);
    }
    resetAuthStateIfNeeded() {
        const authData = this.getFacilitatedFHIRAuthData();
        if (authData) {
            this.setFacilitatedFHIRAuthData(null);
            this.onError(FacilitatedFHIRAuthErrorReason.AUTH_FAILED, authData.key, authData.fhirEndpoint);
        }
    }
}
__decorate([
    observable
], FacilitatedFHIRAuthManager.prototype, "state", void 0);
__decorate([
    computed
], FacilitatedFHIRAuthManager.prototype, "hasCompletedAuth", null);
